(function () {
  function refreshSelected(scope) {
    scope = scope || document;

    var labels = scope.querySelectorAll('label.variant-option__button-label');
    if (!labels.length) return;

    labels.forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;

      label.classList.toggle('is-selected', !!input.checked);
      label.classList.toggle('is-disabled', !!input.disabled);
    });
  }

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refreshSelected(document);
    });
  } else {
    refreshSelected(document);
  }

  // Quand on change une option
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.matches('label.variant-option__button-label input[type="radio"], input[type="radio"]')) {
      refreshSelected(document);
    }
  });

  // Shopify sections (thème editor)
  document.addEventListener('shopify:section:load', function () {
    refreshSelected(document);
  });

  // Si le thème “réhydrate” le DOM
  var mo = new MutationObserver(function () {
    refreshSelected(document);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
